import { NgModule } from '@angular/core';
import { AngularGradientProgressbarComponent } from './angular-gradient-progressbar.component';
import { CommonModule } from '@angular/common';

@NgModule({
  declarations: [AngularGradientProgressbarComponent],
  imports: [CommonModule],
  exports: [AngularGradientProgressbarComponent],
})
export class AngularGradientProgressbarModule {}
